import { Grid, Skeleton, Typography, useMediaQuery } from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../theme/ScrollCarousel.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons";

const ScrollingSection = ({ sections, loading }) => {

    // const beforeChange = (prev, next) => {
    //     const prevSlideElement = document.getElementById(`slide-${prev}`);
    //     const nextSlideElement = document.getElementById(`slide-${next}`);

    //     if (prevSlideElement) prevSlideElement.classList.remove('next-slide-anim');
    //     if (nextSlideElement) nextSlideElement.classList.add('next-slide-anim');
    // };
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const element = document.getElementById("scrolling-carousel");
            if (element) {
                const rect = element.getBoundingClientRect();
                const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
                setIsVisible(isVisible);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);

    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        fade: true,
        // beforeChange: beforeChange,
    };

    const goToPrevSlide = () => {
        console.log("Previous slide clicked");
        if (sliderRef.current) {
            sliderRef.current.slickPrev();
            setCurrentSlide(currentSlide - 1);
        }
    };

    const goToNextSlide = () => {
        console.log("Next slide clicked");
        if (sliderRef.current) {
            sliderRef.current.slickNext();
            setCurrentSlide(currentSlide + 1);
        }
    };

    const mobile = useMediaQuery(theme => theme.breakpoints.down('md'));

    console.log(sections);

    return (
        <Container maxWidth="xl" sx={{ paddingBottom: "80px" }} id="scrolling-carousel">
            {loading ?
                <>
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height="2.1rem"
                        sx={{
                            margin: "-91px auto 1em auto",
                            maxWidth: "600px",
                        }}
                    />
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height="2.1rem"
                        sx={{
                            margin: "0px auto 1em auto",
                            maxWidth: "700px",
                        }}
                    />
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height="330px"
                                sx={{
                                    margin: "0px auto 1em auto",
                                    maxWidth: "600px",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height="440px"
                                sx={{
                                    margin: "0px auto 1em auto",
                                    maxWidth: "600px",
                                }}
                            />
                        </Grid>
                    </Grid>
                </>
                :
                <>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "75px",
                            marginBottom: "-20px",
                            position: "relative",
                            zIndex: "1",
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faArrowCircleLeft}
                            style={{
                                color: "#005EAA",
                                fontSize: "1.5rem",
                                cursor: "pointer",
                            }}
                            onClick={goToPrevSlide}
                        />
                        <FontAwesomeIcon
                            icon={faArrowCircleRight}
                            style={{
                                color: "#005EAA",
                                fontSize: "1.5rem",
                                cursor: "pointer",
                            }}
                            onClick={goToNextSlide}
                        />
                    </Box>
                    <Slider {...settings} ref={sliderRef}>
                        {sections?.map((section, i) => {
                            const slideId = `slide-${i}`;
                            return (
                                <Box
                                    id={slideId}
                                    key={i}
                                >
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            '& > div': {
                                               display: 'block',
                                            },
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={5}

                                        >
                                            <Box
                                                key={i}
                                                sx={{
                                                    transition: 'opacity 0.5s',
                                                    paddingRight: mobile ? '0' : '2rem',
                                                }}
                                            >
                                                <Typography
                                                    variant="h3"
                                                    sx={{
                                                        color: '#E9531C',
                                                        fontSize: '1.5rem',
                                                        fontWeight: '600',
                                                        lineHeight: '2.5rem',
                                                        marginBottom: '1em',
                                                        marginTop: '1em',
                                                    }}
                                                >
                                                    {section.intro}
                                                </Typography>
                                                <Typography variant="p"
                                                    dangerouslySetInnerHTML={{
                                                        __html: section?.content
                                                    }} />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={7}>
                                            <Box
                                                sx={{
                                                    position: 'relative',
                                                    height: '100%',
                                                    width: '100%',
                                                    textAlign: 'center',
                                                    paddingBottom: '56.25%',
                                                    overflow: 'hidden',
                                                    maxWidth: '100%',
                                                    height: 'auto',
                                                }}
                                            >
                                                {section?.media_type && section.media_type === 'video' ?

                                                    <video
                                                        key={i}
                                                        src={section?.video?.url}
                                                        // controls
                                                        playsInline
                                                        autoPlay
                                                        muted
                                                        loop
                                                        style={{
                                                            objectFit: 'contain',
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            width: '100%',
                                                            height: '100%',
                                                        }}
                                                    />
                                                    :
                                                    <img
                                                        key={i}
                                                        src={section?.image}
                                                        alt={section?.intro}
                                                        style={{
                                                            width: '100%',
                                                            objectFit: 'contain',
                                                        }}
                                                    />
                                                }
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            );
                        })}
                    </Slider>
                </>
            }
        </Container>
    );
}

export default ScrollingSection;